import { useTranslation } from "react-i18next";

/** Real facts only. No ratings or user counts (none are live yet). */
const ITEMS = ["tickers", "markets", "prices", "languages", "platforms"] as const;

const ProofStrip = () => {
  const { t } = useTranslation();
  return (
    <section aria-label={t("home.proof.label")} className="px-[22px] pb-[clamp(64px,7vw,96px)]">
      <div className="pf-rv mx-auto max-w-[1200px] border-y border-foreground/10 pb-8 pt-9">
        <ul className="m-0 grid list-none grid-cols-2 gap-x-6 gap-y-8 p-0 text-center md:grid-cols-3 min-[1100px]:grid-cols-5">
          {ITEMS.map((key) => (
            <li key={key}>
              <span className="block text-[30px] font-semibold tabular-nums tracking-[-0.03em] text-foreground">
                {t(`home.proof.${key}.value`)}
              </span>
              <span className="mt-1 block text-sm text-pf-ink2">{t(`home.proof.${key}.label`)}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default ProofStrip;
